import { createStandaloneToast } from '@chakra-ui/react';

// Toast desacoplado da arvore React, para modulos que rodam fora de componentes
// (ex: os interceptors do Axios em client.ts). No Chakra v2 o standalone toast
// compartilha o mesmo store global do hook useToast, entao ele ja renderiza no
// container que o ChakraProvider monta - nao e preciso montar um ToastContainer
// proprio (fazer isso duplicaria toda toast do app).
const { toast } = createStandaloneToast();

export { toast };
